export const ShippIcon = ({
  fill = "currentColor",
  filled,
  size,
  height,
  width,
  label,
  ...props
}) => {
  return (
    <svg
      width={width}
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 512 512'
      fill='#000000'
    >
      <g id='SVGRepo_bgCarrier' strokeWidth='0'></g>
      <g
        id='SVGRepo_tracerCarrier'
        strokeLinecap='round'
        strokeLinejoin='round'
      ></g>
      <g id='SVGRepo_iconCarrier'>
        {" "}
        <path
          style={{ fill: "#B4E66E" }}
          d='M358.614,102.079H50.772c-4.722,0-8.551,3.829-8.551,8.551v179.574h25.653 c9.445,0,17.102,7.656,17.102,17.102c0,9.445-7.658,17.102-17.102,17.102H42.221v25.653c0,4.722,3.829,8.551,8.551,8.551h316.393 V110.63C367.165,105.908,363.336,102.079,358.614,102.079z'
        ></path>{" "}
        <path
          style={{ fill: "#FFDC64" }}
          d='M469.779,238.898H367.165v119.716h136.818v-85.512C503.983,254.212,488.669,238.898,469.779,238.898z '
        ></path>{" "}
        <path
          style={{ fill: "#FFC850" }}
          d='M367.165,264.551h92.638c9.446,0,17.102,7.656,17.102,17.102v76.96h-109.74V264.551z'
        ></path>{" "}
        <path
          style={{ fill: "#FFDC64" }}
          d='M435.574,136.284h-68.409v34.205h94.063v-8.551C461.228,147.769,449.742,136.284,435.574,136.284z'
        ></path>{" "}
        <polygon
          style={{ fill: "#B4E6FF" }}
          points='469.779,238.898 452.676,170.489 367.165,170.489 367.165,238.898 '
        ></polygon>{" "}
        <path
          style={{ fill: "#F1F4FB" }}
          d='M469.779,273.102h34.205v34.205h-17.102c-9.446,0-17.102-7.656-17.102-17.102V273.102z'
        ></path>{" "}
        <path
          style={{ fill: "#E1A546" }}
          d='M427.023,298.756c-25.772,0-48.194,14.265-59.858,35.317v24.541h127.676 C490.624,324.877,461.902,298.756,427.023,298.756z'
        ></path>{" "}
        <path
          style={{ fill: "#FFC850" }}
          d='M476.904,320.412v38.202h17.937C493.005,343.925,486.518,330.686,476.904,320.412z'
        ></path>{" "}
        <circle
          style={{ fill: "#5B5D6E" }}
          cx='427.023'
          cy='367.165'
          r='42.756'
        ></circle>{" "}
        <path
          style={{ fill: "#9BD6FF" }}
          d='M401.37,196.142h57.72l-6.413-25.653h-85.511v68.409h25.653v-34.205 C392.818,199.971,396.647,196.142,401.37,196.142z'
        ></path>{" "}
        <path
          style={{ fill: "#A0D755" }}
          d='M144.835,298.756c-21.593,0-40.819,10.028-53.355,25.653H67.875H42.221v25.653 c0,4.722,3.829,8.551,8.551,8.551h316.393v-34.205H198.19C185.654,308.784,166.428,298.756,144.835,298.756z'
        ></path>{" "}
        <circle
          style={{ fill: "#5B5D6E" }}
          cx='144.835'
          cy='367.165'
          r='42.756'
        ></circle>{" "}
        <path d='M476.158,231.363l-13.259-53.035c3.625-0.77,6.345-3.986,6.345-7.839v-8.551c0-18.566-15.105-33.67-33.67-33.67h-60.392 V110.63c0-9.136-7.432-16.568-16.568-16.568H50.772c-9.136,0-16.568,7.432-16.568,16.568V256c0,4.427,3.589,8.017,8.017,8.017 s8.017-3.589,8.017-8.017V110.63c0-0.295,0.239-0.534,0.534-0.534h307.841c0.295,0,0.534,0.239,0.534,0.534v145.372 c0,4.427,3.589,8.017,8.017,8.017c4.427,0,8.017-3.589,8.017-8.017v-9.088h94.569c0.007,0,0.014,0.002,0.021,0.002 c0.007,0,0.015-0.001,0.022-0.001c11.637,0.007,21.518,7.646,24.912,18.171h-24.928c-4.427,0-8.017,3.589-8.017,8.017v17.102 c0,13.851,11.268,25.119,25.119,25.119h9.086v35.273h-20.962c-6.886-19.882-25.787-34.205-47.982-34.205 s-41.097,14.322-47.982,34.205h-3.86v-60.392c0-4.427-3.589-8.017-8.017-8.017c-4.427,0-8.017,3.589-8.017,8.017v60.391H192.817 c-6.886-19.883-25.787-34.205-47.982-34.205s-41.097,14.322-47.982,34.205H50.772c-0.295,0-0.534-0.239-0.534-0.534v-17.637h34.739 c4.427,0,8.017-3.589,8.017-8.017c0-4.427-3.589-8.017-8.017-8.017H8.017c-4.427,0-8.017,3.589-8.017,8.017 c0,4.427,3.589,8.017,8.017,8.017h26.188v17.637c0,9.136,7.432,16.568,16.568,16.568h43.304c-0.002,0.178-0.014,0.355-0.014,0.534 c0,27.996,22.777,50.772,50.772,50.772s50.772-22.776,50.772-50.772c0-0.18-0.012-0.356-0.014-0.534h180.67 c-0.002,0.178-0.014,0.355-0.014,0.534c0,27.996,22.777,50.772,50.772,50.772c27.995,0,50.772-22.776,50.772-50.772 c0-0.18-0.012-0.356-0.014-0.534h26.203c4.427,0,8.017-3.589,8.017-8.017v-85.512C512,251.99,496.423,234.448,476.158,231.363z M375.182,178.505h71.235l13.094,52.376h-84.329V178.505z M435.574,144.301c9.725,0,17.637,7.912,17.637,17.637v0.534h-78.029 v-18.171H435.574z M144.835,401.904c-19.155,0-34.739-15.583-34.739-34.739c0-19.156,15.584-34.739,34.739-34.739 c19.155,0,34.739,15.583,34.739,34.739C179.574,386.321,163.99,401.904,144.835,401.904z M427.023,401.904 c-19.155,0-34.739-15.583-34.739-34.739c0-19.156,15.584-34.739,34.739-34.739c19.155,0,34.739,15.583,34.739,34.739 C461.762,386.321,446.178,401.904,427.023,401.904z M486.881,299.29c-5.01,0-9.086-4.076-9.086-9.086v-9.086h18.171v18.171H486.881z '></path>{" "}
        <path d='M144.835,350.597c-9.136,0-16.568,7.432-16.568,16.568c0,9.136,7.432,16.568,16.568,16.568 c9.136,0,16.568-7.432,16.568-16.568C161.403,358.029,153.971,350.597,144.835,350.597z'></path>{" "}
        <path d='M427.023,350.597c-9.136,0-16.568,7.432-16.568,16.568c0,9.136,7.432,16.568,16.568,16.568s16.568-7.432,16.568-16.568 C443.591,358.029,436.159,350.597,427.023,350.597z'></path>{" "}
        <path d='M205.228,324.409c0,4.427,3.589,8.017,8.017,8.017H332.96c4.427,0,8.017-3.589,8.017-8.017c0-4.427-3.589-8.017-8.017-8.017 H213.244C208.817,316.392,205.228,319.982,205.228,324.409z'></path>{" "}
        <path d='M25.119,298.221h102.614c4.427,0,8.017-3.589,8.017-8.017c0-4.427-3.589-8.017-8.017-8.017H25.119 c-4.427,0-8.017,3.589-8.017,8.017C17.102,294.632,20.692,298.221,25.119,298.221z'></path>{" "}
        <path d='M267.434,173.371l-71.292,71.291l-37.087-37.087c-3.131-3.131-8.207-3.131-11.337,0c-3.131,3.131-3.131,8.206,0,11.337 l42.756,42.756c1.565,1.566,3.617,2.348,5.668,2.348s4.103-0.782,5.668-2.348l76.96-76.96c3.131-3.131,3.131-8.206,0-11.337 C275.641,170.241,270.564,170.241,267.434,173.371z'></path>{" "}
      </g>
    </svg>
  );
};
